import * as React from 'react';
import { notification, } from 'antd';
import { inject, observer } from 'mobx-react';
import EditTenant from './components/editTenant';
import CreateTenant from './components/createTenant';
import { RcFile } from 'antd/lib/upload';
import { DataView } from '../../components/Controls/Views/dataView';
import AppComponentBase from '../../components/AppComponentBase';
import { EntityDto } from '../../services/dto/entityDto';
import { L } from '../../lib/abpUtility';
import Stores from '../../stores/storeIdentifier';
import TenantStore from '../../stores/tenantStore';
import { RelatedEntityTypes } from '../../components/EntityConfigs/relatedEntityTypes';
import TenantCard from '../../components/Controls/Views/Cards/tenantCard';
import ToastDrawer from '../../components/Controls/Drawers/toastDrawer';
import CategoryTitle from '../../components/Controls/Widgets/categoryTitle';
import { GetCurrentLoginInformations } from '../../services/session/dto/getCurrentLoginInformations';
import SessionStore from '../../stores/sessionStore';
import { ShopOutlined, ShopTwoTone } from '@ant-design/icons';
import { FormInstance } from 'antd/lib/form/Form';
import { SummaryViewTypes } from '../../components/EntityConfigs/summaryViewTypes';
import { setLang, getLocale } from '@antv/s2';
import { itemTypes } from '../../components/EntityConfigs/itemTypes';
import { PermissionNames } from '../../components/EntityConfigs/permissionNames';

export interface ITenantProps {
  tenantStore: TenantStore;
  sessionStore: SessionStore;
}

export interface ITenantState {
  reportDataConfig: any;
  currentTab: string;
  loading: boolean;
  deleteDrawerVisible: boolean;
  createModalVisible: boolean;
  editModalVisible: boolean;
  maxResultCount: number;
  skipCount: number;
  tenantId: number;
  filter: string;
  cardHeight: string;
  formSize: string;
  cardSize: string;
  searchSize: string;
  tableSize: string;
  isMobile: boolean;
  collapseTitle: boolean;

  currentUserID: number;
  currentLoginName: string;
  currentLoginLastName: string;
  profileImageID: number;
  profileImageURL: string;
  currentUsername: string;
  currentEmailAddres: string;

  currentTenantName: string;
  primaryTenantColor: string;
  secondaryTenantColor: string;
  defaultProfileImage: string;
  tenantImageID: number;
  tenantImageURL: string;
  tenantTitle: string;

  tenantSubscriptionStart: string;
  tenantSubscriptionEnd: string;
  tenantSubscriptionActive: boolean;
  currentState: number;
  roles: string[];
  currentStates: any;

  titleStringLength: number;
  subtitleStringLength: number;

  createOwn: boolean;
  createOthers: boolean;
  editOwn: boolean;
  editOthers: boolean;
  deleteOwn: boolean;
  deleteOthers: boolean;
  allowConfiguration: boolean;
}


@inject(Stores.TenantStore, Stores.SessionStore)
@observer
class Tenant extends AppComponentBase<ITenantProps, ITenantState> {

  tenantEdit_FormRef = React.createRef<FormInstance>();

  state = {
    createOwn: false,
    createOthers: false,
    editOwn: false,
    editOthers: false,
    deleteOwn: false,
    deleteOthers: false,
    allowConfiguration: false,

    reportDataConfig: [],
    currentState: 1,
    currentStates: [],
    collapseTitle: false,
    deleteDrawerVisible: false,
    createModalVisible: false,
    editModalVisible: false,
    isMobile: false,
    cardHeight: '',
    defaultProfileImage: '',
    maxResultCount: 50,
    skipCount: 0,
    tenantId: 0,
    filter: '',
    loading: true,
    dataTableText: L('Fetching Companies...'),
    formSize: '',
    cardSize: '',
    searchSize: '',
    tableSize: '',

    currentTab: 'swilab',

    roles: [],

    currentUserID: 0,
    currentLoginName: '',
    currentLoginLastName: '',
    profileImageID: 0,
    profileImageURL: '',
    currentUsername: '',
    currentEmailAddres: '',

    currentTenantName: '',
    primaryTenantColor: '#dadada',
    secondaryTenantColor: '#dadada',

    tenantImageID: 0,
    tenantImageURL: 'https://swilab.com/images/devLogo.png',
    tenantTitle: '',

    tenantSubscriptionStart: '',
    tenantSubscriptionEnd: '',
    tenantSubscriptionActive: false,
    titleStringLength: 20,
    subtitleStringLength: 20

  };

  async getLoginInfo() {

    if (this.state.currentUserID === 0) {

      this.setState({
        loading: true,
      });

      await this.props.sessionStore.getCurrentLoginInformations();
      var currentLoginInfo: GetCurrentLoginInformations = this.props.sessionStore.currentLogin;

      this.setState({

        currentLoginName: currentLoginInfo.user.name,
        currentLoginLastName: currentLoginInfo.user.surname,
        profileImageID: currentLoginInfo.user.profileImageID,
        profileImageURL: currentLoginInfo.user.profileImageURL,
        currentUsername: currentLoginInfo.user.userName,
        currentEmailAddres: currentLoginInfo.user.emailAddress,
        currentTenantName: currentLoginInfo.tenant.tenancyName,
        primaryTenantColor: currentLoginInfo.tenant.primaryColor,
        secondaryTenantColor: currentLoginInfo.tenant.secondaryColor,
        tenantImageID: currentLoginInfo.tenant.profileImageID,
        //tenantImageURL: currentLoginInfo.tenant.profileImageURL,
        tenantTitle: currentLoginInfo.tenant.title,
        //tenantSubscriptionStart: currentLoginInfo.tenant.SubscriptionStart.toDateString(),
        //tenantSubscriptionEnd: currentLoginInfo.tenant.SubscriptionExpire.toDateString(),
        tenantSubscriptionActive: currentLoginInfo.tenant.subscriptionActive,
        roles: currentLoginInfo.roles,
        currentUserID: currentLoginInfo.user.userID

      });






    }



  }

  async componentDidMount() {

    setLang('en_US')
    getLocale()
    if (window.innerWidth <= 1000) {

      if (window.innerWidth <= 800) {

        if (window.innerWidth <= 740) {
          this.setState({ titleStringLength: 20, subtitleStringLength: 23 })
        }
        else {
          this.setState({ titleStringLength: 12, subtitleStringLength: 15 })
        }
      }
      else {
        this.setState({ titleStringLength: 16, subtitleStringLength: 20 })
      }
    }
    else {
      this.setState({ titleStringLength: 20, subtitleStringLength: 23 })
    }


    if (this.isGranted(PermissionNames.Tenants) === true) {
      if (this.isGranted(PermissionNames.Tenants_Own) === true) {
        if (this.isGranted(PermissionNames.Tenants_CreateOwn) === true) {
          this.setState({ createOwn: true });
        }
        if (this.isGranted(PermissionNames.Tenants_EditOwn) === true) {
          this.setState({ editOwn: true });
        }
        if (this.isGranted(PermissionNames.Tenants_DeleteOwn) === true) {
          this.setState({ deleteOwn: true });
        }
      }

      if (this.isGranted(PermissionNames.Tenants_Others) === true) {
        if (this.isGranted(PermissionNames.Tenants_CreateOthers) === true) {
          this.setState({ createOthers: true });
        }

        if (this.isGranted(PermissionNames.Tenants_EditOthers) === true) {
          this.setState({ editOthers: true });
        }

        if (this.isGranted(PermissionNames.Tenants_DeleteOthers) === true) {
          this.setState({ deleteOthers: true });
        }
      }
    }
    
    this.setState({
      formSize: (window.innerWidth).toString() + 'px',
      tableSize: (window.innerWidth * 0.95).toString() + 'px',
    });

    if (window.innerWidth >= 550) {
      this.setState({
        cardHeight: '60px',
        isMobile: false
      });
    }
    else {
      this.setState({
        cardHeight: '100px',
        isMobile: true
      });
    }

    if (window.innerWidth >= 750) {
      this.setState({
        collapseTitle: false
      });
    }
    else {
      this.setState({
        collapseTitle: true
      });
    }

    await this.getLoginInfo();
    await this.props.tenantStore.resetAssetCache();
    window.addEventListener('resize', this.handleResize);
 

    await this.getAll();
    this.setState({
      loading: false,
    });
  }


  updateRuleConfig = async (config: any) => {
    this.setState({ loading: true });
    this.setState({ reportDataConfig: config });
    this.setState({ loading: false });
  }

  async handleTabChange(e: any) {

    this.setState({ currentTab: e });

  };

  async getAll() {
    await this.props.tenantStore.getAll({ maxResultCount: this.state.maxResultCount, skipCount: this.state.skipCount, keyword: this.state.filter });

    this.setState({ reportDataConfig: [] });
    this.setState({
      reportDataConfig: this.props.tenantStore.dataExportTable
    })
  }

  handleResize = () => {
    if (window.innerWidth <= 1000) {

      if (window.innerWidth <= 800) {

        if (window.innerWidth <= 740) {
          this.setState({ titleStringLength: 20, subtitleStringLength: 23 })
        }
        else {
          this.setState({ titleStringLength: 12, subtitleStringLength: 15 })
        }
      }
      else {
        this.setState({ titleStringLength: 16, subtitleStringLength: 20 })
      }
    }
    else {
      this.setState({ titleStringLength: 20, subtitleStringLength: 23 })
    }

    this.setState({
      formSize: (window.innerWidth).toString() + 'px',
      tableSize: (window.innerWidth * 0.95).toString() + 'px'
    });

    if (window.innerWidth >= 550) {
      this.setState({
        cardHeight: '60px',
        isMobile: false
      });
    }
    else {
      this.setState({
        cardHeight: '100px',
        isMobile: true
      });
    }

    if (window.innerWidth >= 750) {
      this.setState({
        collapseTitle: false
      });
    }
    else {
      this.setState({
        collapseTitle: true
      });
    }

  }

  handleTableChange = (pagination: any) => {
    this.setState({ skipCount: (pagination.current - 1) * this.state.maxResultCount! }, async () => await this.getAll());
  };

  EditModal = () => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
    });
  };

  CreateModal = () => {
    this.setState({
      createModalVisible: !this.state.createModalVisible,
    });
  };

  createOrUpdateModalOpen(entityDto: EntityDto) {

    if (entityDto.id === 0) {
      this.props.tenantStore.createTenant();
      this.setState({ tenantId: entityDto.id });
      this.CreateModal();
    }
    else {
      notification.open({
        message: L('Error'),
        description:
          L('Unable to create existing Tenant')
      });
    }



  }

  async editTenant(entityDto: EntityDto) {

    if (entityDto.id !== 0) {

      this.setState({ defaultProfileImage: '' });
      this.props.tenantStore.createTenant();
      this.setState({ tenantId: entityDto.id });
      this.EditModal();
      this.setState({ loading: true });

      await this.props.tenantStore.get(entityDto);
      this.props.tenantStore.profileID = this.props.tenantStore.editTenant.profileImageID;
      this.setState({ currentState: this.props.tenantStore.editTenant.currentState, currentStates: this.props.tenantStore.tenantStates });


      this.tenantEdit_FormRef.current?.setFieldsValue(this.props.tenantStore.editTenant);
      this.setState({ loading: false });


      if (this.props.tenantStore.profileID !== 0) {
        let returnURL = await this.props.tenantStore.getProfileImage(this.props.tenantStore.profileID);
        this.setState({ defaultProfileImage: returnURL });
      }

    }
    else {
      notification.open({
        message: L('Error'),
        description:
          L('Unable to edit new Tenant')
      });
    }



  }

  onDeleteOk(input: number) {
    const self = this;
    self.props.tenantStore.delete({ id: input });
    this.setState({ deleteDrawerVisible: false })
    notification.open({
      message: L('Confirmation'),
      description:
        L('Tenant Successfully Deleted')
    });
  }

  delete(input: EntityDto) {
    this.setState({ tenantId: input.id })
    this.setState({ deleteDrawerVisible: true })
  }

  handleCreate = (values: any) => {

    let formattedValues = values;
    formattedValues.userID = 0;



    this.props.tenantStore.create(formattedValues);

    notification.open({
      message: L('Confirmation'),
      description:
        L('Company Successfully Created')
    });

    this.setState({ tenantId: 0, createModalVisible: false, editModalVisible: false, defaultProfileImage: '' });
    this.getAll();
  };


  handleUpdate = (values: any) => {

    this.props.tenantStore.update(values);

    notification.open({
      message: L('Confirmation'),
      description:
        L('Company Successfully Updated')
    });

    this.setState({ tenantId: 0, createModalVisible: false, editModalVisible: false, defaultProfileImage: '' });
    this.getAll();
  };


  uploadImage = async (file: RcFile) => {
    let result = await this.props.tenantStore.uploadProfileImage(file);
    return result.url;
  }

  handleSearch = (value: string) => {
    this.setState({ filter: value }, async () => await this.getAll());
  };


  handleCancel = () => {
    this.setState({
      editModalVisible: false,
      createModalVisible: false,
      defaultProfileImage: '',
      tenantId: 0,
    })

    this.props.tenantStore.resetAssetCache();
  };


  getProfileImage = async (recordID: number) => {
    let result = await this.props.tenantStore.getProfileImage(recordID);
    return result;
  }


  public render() {
    const columns = [
      {
        title: L('Tenant'), dataIndex: 'tenant', key: 'tenant', style: { backgroundColor: 'black' },
        render: (text: string, item: any) => {
          return {
            props: {
              style: { background: '#f5f5f5', paddingTop: '10px', paddingBottom: '10px', }
            },
            children: <div>

              {this.props.tenantStore.tenants.totalCount === 0 ?

                <TenantCard
                  entityStates={this.props.tenantStore.tenantStates}
                  currentState={item.currentStage === undefined ? 0 : item.curentState}
                  currentStage={item.currentState}
                  stages={this.props.tenantStore.tenantStates}
                  subscriptionType={item.subscriptionType}
                  defaultIcon={<ShopOutlined twoToneColor={this.state.secondaryTenantColor} style={{ fontSize: 45, padding: '5px' }} />}
                  getProfileImage={() => this.getProfileImage(item.profileImageID)}
                  formSize={this.state.formSize}
                  id={item.id}
                  primaryColor={this.state.primaryTenantColor}
                  secondaryColor={this.state.secondaryTenantColor}
                  title={item.name.length > this.state.titleStringLength ? item.name.substr(0, this.state.titleStringLength) + '...' : item.name}
                  subTitle={item.title.length > this.state.subtitleStringLength ? item.title.substr(0, this.state.subtitleStringLength) + '...' : item.title}
                  cardDelete={() => this.delete({ id: item.id })}
                  cardView={() => this.editTenant({ id: item.id })}
                  cardEdit={() => this.editTenant({ id: item.id })} />

                :
                <TenantCard
                  entityStates={this.props.tenantStore.tenantStates}
                  currentState={item.currentStage === undefined ? 0 : item}
                  currentStage={item.currentState}
                  stages={this.props.tenantStore.tenantStates}
                  subscriptionType={item.subscriptionType}
                  defaultIcon={<ShopOutlined twoToneColor={this.state.secondaryTenantColor} style={{ fontSize: 45, padding: '5px' }} />}
                  getProfileImage={() => this.getProfileImage(item.profileImageID)}
                  formSize={this.state.formSize}
                  id={item.id}
                  primaryColor={this.state.primaryTenantColor}
                  secondaryColor={this.state.secondaryTenantColor}
                  title={item.name.length > this.state.titleStringLength ? item.name.substr(0, this.state.titleStringLength) + '...' : item.name}
                  subTitle={item.title.length > this.state.subtitleStringLength ? item.title.substr(0, this.state.subtitleStringLength) + '...' : item.title}
                  cardDelete={() => this.delete({ id: item.id })}
                  cardView={() => this.editTenant({ id: item.id })}
                  cardEdit={() => this.editTenant({ id: item.id })} />}

            </div>
          };
        }
      },
    ];

    return (
      <div style={{ marginTop: '25px', textAlign: 'center', }}>
        <div>

          <CategoryTitle
            title={L('Tenants')}
            isMobile={this.state.collapseTitle}
            primaryColor={this.state.primaryTenantColor}
            secondaryColor={this.state.secondaryTenantColor}
          />


          <DataView
            allowCreate={this.state.createOthers}
            dataSourceAnalytic={this.props.tenantStore.dataExportTable_Analytic}
            updateRuleConfig={(e) => this.updateRuleConfig(e)}
            permissionsName={'Tenants'}
            search_Status={[]}
            moduleType={itemTypes.Tenants}
            dataSource={this.props.tenantStore.dataExportTable}
            dataSummary={this.props.tenantStore.tenants}
            summaryViewType={SummaryViewTypes.list}
            setSummaryViewType={(e) => ''}

            search_Hashtags={this.props.tenantStore.search_Hashtags}
            search_Mentions={this.props.tenantStore.search_Mentions}
            moduleName={L('Tenants')}
            headerLoading={this.props.tenantStore.tenants === undefined && this.state.loading === true ? false : this.state.loading}
            showHeader={false}
            primaryColor={this.state.primaryTenantColor}
            secondaryColor={this.state.secondaryTenantColor}
            entityType={RelatedEntityTypes.Entity}
            dataTableImage={<ShopTwoTone style={{ fontSize: '4em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />}
            dataTableText={this.state.dataTableText}
            columns={columns}
            handleSearch={(e) => this.props.tenantStore.getAll({
              keyword: e,
              maxResultCount: 50,
              skipCount: 0
            })}
            createOrUpdateModalOpen={(e) => this.createOrUpdateModalOpen(e)}
            showHelp={() => ''}
          />


        </div>


        <EditTenant
          currentState={this.state.currentState}
          tenantStates={this.state.currentStates}
          entityID={this.state.tenantId}
          profileImageID={this.props.tenantStore.profileID}
          formRef={this.tenantEdit_FormRef}
          isMobile={this.state.isMobile}
          visible={this.state.editModalVisible}
          loading={this.state.loading}
          primaryColor={this.state.primaryTenantColor}
          secondaryColor={this.state.secondaryTenantColor}
          defaultImage={this.state.defaultProfileImage}
          onCreate={this.handleUpdate}
          onCancel={this.handleCancel}
          uploadProfileImage={this.uploadImage}
        />

        <CreateTenant
          tenantStates={this.props.tenantStore.tenantStates}
          profileImageID={this.props.tenantStore.profileID}
          isMobile={this.state.isMobile}
          visible={this.state.createModalVisible}
          loading={this.state.loading}
          primaryColor={this.state.primaryTenantColor}
          secondaryColor={this.state.secondaryTenantColor}
          defaultImage={''}
          onCreate={this.handleCreate}
          onCancel={this.handleCancel}
          uploadProfileImage={this.uploadImage}
        />

        <ToastDrawer
          isMobile={this.state.isMobile}
          primaryColor={this.state.primaryTenantColor}
          secondaryColor={this.state.secondaryTenantColor}
          visible={this.state.deleteDrawerVisible}
          text={L('Delete Tenant?')}
          idReference={this.state.tenantId}
          includeConfirm={true}
          onCancel={() => this.setState({ deleteDrawerVisible: false })}
          onConfirm={() => this.onDeleteOk(this.state.tenantId)}
        />

      </div>
    );
  }
}

export default Tenant;
